import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { historialEntregasHologramas } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import { v4 as uuidv4 } from 'uuid';
import { buscarSolicitudByFolio } from '../../../redux/DuckUsuarioDeveloper/SolicitudesDevDuck';
import { IniciarProceso, IniciarProceso2, obtenerClientesAsamblea, obtenerClientesPersona } from '../../../redux/DuckUsuarioDeveloper/ConstanciasDevDuck';
import excelJS from 'exceljs'

const ConstanciasDevComponent = () => {

    const dispatch = useDispatch()
    const solicitudesDev = useSelector(store => store.UsuarioDeveloper.solicitudesDev)

    const [files, setFiles] = React.useState([])
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles(selectedFiles);
    };
    const buscarSolicitud = async () => {
        await dispatch(IniciarProceso(files))
    }


    const generarReporte = async () => {
        let res = await dispatch(obtenerClientesPersona())
        console.log('los datos es ', res)
        const workbook = new excelJS.Workbook();
        const worksheetSolicitudes = workbook.addWorksheet("SOLICITUDES");
        let abc = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'];
        let arregloSolicitudes = []
        for (const i in res.payload) {
            let fila = res?.payload[i]
            let domicilio = fila.domiciliofiscalcliente?.[0]

            let cadena = ''
            for (const j in fila?.actividadcliente) {
                if (cadena === '') cadena += fila?.actividadcliente?.[j]?.tipoactividad?.actividad
                else cadena += ',' + fila?.actividadcliente?.[j]?.tipoactividad?.actividad
            }
            let arregloCadena = cadena.split(',')
            let combinacionCadena = ''
            let contador = 1
            for (const j in arregloCadena) {
                if (arregloCadena.length === 1) {
                    combinacionCadena += arregloCadena[j]
                } else {
                    if (arregloCadena.length === (contador + 1)) {
                        combinacionCadena += arregloCadena[j] + ' y '
                        contador++
                    } else {

                        combinacionCadena += arregloCadena[j]
                        if (arregloCadena.length !== contador) {
                            combinacionCadena += ', '
                        }
                        contador++
                    }

                }

            }
            arregloSolicitudes.push({
                numcliente: fila.numerosocio,
                razonSocial: fila.nombrerazonsocial,
                genero: fila.informacionpersonafisicacliente?.[0]?.sexo,
                domicilio: domicilio?.calle + ', ' + domicilio?.numerointerior + ' ' + domicilio?.numeroexterior + ' ' +
                    domicilio?.colonia + ' ' + domicilio?.localidad + ' ' + domicilio?.municipioalcaldia + ' ' + domicilio?.estado + ' ' +
                    domicilio?.codigopostal,
                cadena: combinacionCadena
            })
        }
        worksheetSolicitudes.columns = [
            { header: "No DE CLIENTE", key: "numcliente", width: 20 },
            { header: "NOMBRE RAZON SOCIAL", key: "razonSocial", width: 50 },
            { header: "GENERO", key: "genero", width: 15 },
            { header: "DOMICILIO", key: "domicilio", width: 40 },
            { header: "CADENA PRODUCTIVA", key: "cadena", width: 40 },
        ];
        abc.slice(0, 5).map(key => {
            worksheetSolicitudes.getCell(key).fill = {
                type: 'pattern',
                pattern: 'solid',
                height: 150,
                fgColor: { argb: 'gray' },
                backgroundColor: 'white'
            };
            worksheetSolicitudes.getCell(key).alignment = {
                vertical: 'middle',
                horizontal: 'center'
            };
        });
        arregloSolicitudes.forEach((solicitud) => {
            worksheetSolicitudes.addRow(solicitud);
            const row = worksheetSolicitudes.lastRow;
            row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
        worksheetSolicitudes.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
        });

        //await dispatch(actualizarLoadingApp_false())
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            let EXCEL_EXTENSION = '.xlsx';
            const blob = new Blob([buffer], { type: fileType });
            saveAs(blob, 'ReporteSolicitudes' + EXCEL_EXTENSION);
        } catch (err) {
            console.log("error ", err)
        }
    }

    const generarReporteAsamblea = async () => {
        //let res = await dispatch(obtenerClientesAsamblea())
        const response = await fetch('http://localhost:7778/api/FormularioAsamblea/obtenerRegistros', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const result = await response.json();
            console.log('los result es ', result)
            const workbook = new excelJS.Workbook();
            const worksheetSolicitudes = workbook.addWorksheet("CLIENTES");
            let abc = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1', 'K1', 'L1', 'M1', 'N1', 'O1', 'P1', 'Q1', 'R1', 'S1', 'T1', 'U1', 'V1', 'W1', 'X1', 'Y1', 'Z1'];
            let arregloSolicitudes = []
            for (const i in result.data) {
                let fila = result.data[i]

                arregloSolicitudes.push({
                    nombre_completo: fila.nombre_completo,
                    correo_electronico: fila.correo_electronico,
                    estado_origen: fila.estado_origen,
                    numero_asociado: fila.numero_asociado,
                    telefono_contacto: fila.telefono_contacto,
                    plaza_28: fila.plaza_28 == true ? 'si' : 'no',
                    plaza_29: fila.plaza_29 == true ? 'si' : 'no',
                    laboratorio_29: fila.laboratorio_29 == true ? 'si' : 'no',
                    comentario: fila.comentario,
                    codigo: fila.codigo,
                    tipoUsuario:fila.tipoUsuario,
                    universidad:fila.universidad
                })
            }
            worksheetSolicitudes.columns = [
                { header: "NOMBRE", key: "nombre_completo", width: 90 },
                { header: "CORREO", key: "correo_electronico", width: 50 },
                { header: "ESTADO ORIGEN", key: "estado_origen", width: 50 },
                { header: "NO. ASOCIADO", key: "numero_asociado", width: 40 },
                { header: "TELEFONO", key: "telefono_contacto", width: 40 },
                { header: "Hotel Fortín Plaza, 28", key: "plaza_28", width: 40 },
                { header: "Hotel Fortín Plaza, 29", key: "plaza_29", width: 40 },
                { header: "Inauguración del Laboratorio COMERCAM, 29", key: "laboratorio_29", width: 40 },
                { header: "COMENTARIO", key: "comentario", width: 100 },
                { header: "CODIGO", key: "codigo", width: 40 },
                { header: "UNIVERSIDAD", key: "universidad", width: 40 },
                { header: "TIPO USAURIO", key: "tipoUsuario", width: 40 },

            ];
            abc.slice(0, 12).map(key => {
                worksheetSolicitudes.getCell(key).fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    height: 150,
                    fgColor: { argb: 'gray' },
                    backgroundColor: 'white'
                };
                worksheetSolicitudes.getCell(key).alignment = {
                    vertical: 'middle',
                    horizontal: 'center'
                };
            });
            arregloSolicitudes.forEach((solicitud) => {
                worksheetSolicitudes.addRow(solicitud);
                const row = worksheetSolicitudes.lastRow;
                row.getCell(1).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(2).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(3).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(4).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(5).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(6).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(7).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(8).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(9).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(10).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(11).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                row.getCell(12).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });
            worksheetSolicitudes.getRow(1).eachCell((cell) => {
                cell.font = { bold: true };
            });

            //await dispatch(actualizarLoadingApp_false())
            try {
                const buffer = await workbook.xlsx.writeBuffer();
                const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const blob = new Blob([buffer], { type: fileType });
                saveAs(blob, 'Clientes' + EXCEL_EXTENSION);
            } catch (err) {
                console.log("error ", err)
            }
            //alert(result.message); // Mostrar mensaje de éxito
        } else {
            alert('Error al enviar el formulario');
        }
        console.log('los datos es ', res)

    }



    return (
        <div className="container" style={{ height: 500 }}>

            <div className='row' style={{ marginTop: '5%', alignContent: 'center', justifyContent: 'center' }}>
                <input type="file" accept=".kml" multiple onChange={handleFileChange} />
                <button onClick={() => buscarSolicitud()} className='btn btn-outline-success'>INICIAR PROCESO MIGRACIÓN</button>
                <button onClick={() => buscarSolicitud2()} className='btn btn-outline-success'>INICIAR PROCESO MIGRACIÓN 2</button>

                <button onClick={() => generarReporte()} className='btn btn-outline-success'>Generar Reportes</button>




                <button onClick={() => generarReporteAsamblea()} className='btn btn-outline-success'>Generar Reportes Asamblea</button>
            </div>

        </div>
    );

};
export default ConstanciasDevComponent